import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// material-ui icons
import Person from "@material-ui/icons/Person";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import Checkbox from '@material-ui/core/Checkbox';
import moment from 'moment'

import { getUserData } from '../../utils/common'

// core components
import Table from "components/Table/Table.jsx";
import Button from "components/CustomButtons/Button.jsx";

import style from "assets/jss/material-kit-pro-react/views/componentsSections/contentAreas.jsx";
import styles from "assets/jss/customStyle.jsx";
import classNames from "classnames";

import NavigationBar from "../../components/inc/NavigationBar.jsx";
import Clearfix from "../../components/Clearfix/Clearfix.jsx";
// import StepWizard from "../../components/StepWizard/StepWizard.jsx";
import projectListPageStyle from "../../assets/jss/projectListPageStyle.jsx";
import { getProjectList } from "../../actions/project";
import { getUserStoryDetails, updateExistingBid } from "../../actions/myBids";
import connect from "react-redux/es/connect/connect";
import LoadingComponent from "../../components/inc/LoadingComponent.jsx";
import PageTitle from "../../components/inc/PageTitle.jsx";
import { Link } from "react-router-dom";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import { cardTitle } from "../../assets/jss/material-kit-pro-react.jsx";



class DetailStories extends React.Component {
  componentDidMount() {
    const { getUserStoryDetails } = this.props;
    const { storyId, spirntId, id } = this.props.match.params;
    getUserStoryDetails(id, spirntId, storyId);
  }

  handleChange = (bid) => () => {
    const { storyId, spirntId, id } = this.props.match.params;
    const { updateExistingBid } = this.props;
    const userData = getUserData();

    updateExistingBid(id, spirntId, bid._id, {
      storyId: storyId,
      userId: bid.user,
      awarded: !bid.awarded
    }, {
        id, spirntId, storyId
      })

  }


  render() {
    const { classes, isFetching, stories } = this.props;

    const { projectTitle, sprintTitle } = this.props.location.state;

    const { storyId } = this.props.match.params;

    let story;

    if (stories && stories[storyId]) {
      story = stories[storyId]
    }

    // if (story)
    //   story.bidList = [{
    //     "_id": "string",
    //     "user": "string",
    //     "story": "string",
    //     "minutesEstimate": "string",
    //     "completionEstimate": "string",
    //     "awarded": true,
    //     "createdAt": 0,
    //     "updatedAt": 0
    //   }]

    const fillButtons = [
      { color: "info", icon: Person },
      { color: "success", icon: Edit },
      { color: "danger", icon: Close }
    ].map((prop, key) => {
      return (
        <Button justIcon size="sm" color={prop.color} key={key}>
          <prop.icon />
        </Button>
      );
    });
    const simpleButtons = [
      { color: "info", icon: Person },
      { color: "success", icon: Edit },
      { color: "danger", icon: Close }
    ].map((prop, key) => {
      return (
        <Button simple justIcon size="sm" color={prop.color} key={key}>
          <prop.icon />
        </Button>
      );
    });
    const roundButtons = [
      { color: "info", icon: Person },
      { color: "success", icon: Edit },
      { color: "danger", icon: Close }
    ].map((prop, key) => {
      return (
        <Button round justIcon size="sm" color={prop.color} key={key}>
          <prop.icon />
        </Button>
      );
    });
    return (
      <div>
        <div style={styles.removePadding}>
          <NavigationBar />
        </div>


        {
          isFetching &&
          <LoadingComponent isLoading={true} />
        }

        {
          !!story &&
          <div className={classNames(classes.main)}>
            <div style={styles.projectListSection}>
              <PageTitle title={`Project: ${projectTitle}`} />
              <PageTitle title={`Sprint : ${sprintTitle}`} />

              <Card style={{ width: "100%" }}>
                <CardBody>
                  <h4 className={classes.cardTitle}><b>User Story :</b></h4>
                  <p>{story.title}</p>
                  <h4 className={classes.cardTitle}><b>Description :</b></h4>
                  <p>{story.description}</p>
                  <h4 className={classes.cardTitle}><b>Sucess Criteria :</b></h4>
                  {
                    story.criteria.map((c, i) => <p key={i}>{`${i + 1} - ${c.text}`}</p>)
                  }
                </CardBody>
              </Card>

              <PageTitle title="Bids :" />
              <Card style={{ width: "100%" }}>
                <CardBody>
                  <Table
                    striped
                    tableHead={[
                      "#",
                      "User",
                      "Bid placed on",
                      "Estimated Work Effort",
                      "Completion Estimation",
                      "Status",
                      "Action"
                    ]}
                    tableData={
                      story.bidList.map((bid, i) => {
                        return [
                          i + 1,
                          bid.user,
                          moment(bid.createdAt).format("DD MMM YYYY hh:mm A"),
                          bid.minutesEstimate + " minutes",
                          bid.completionEstimate,
                          bid.awarded ? "Assigned" : "Unassigned",
                          <div><Checkbox
                            checked={bid.awarded}
                            onChange={this.handleChange(bid)}
                            value="checkedA"
                            inputProps={{
                              'aria-label': 'primary checkbox',
                            }}
                          /></div>
                        ]
                      })
                    }
                    customCellClasses={[
                      classes.textCenter,
                      classes.textRight,
                      classes.textRight,
                      classes.textRight
                    ]}
                    customClassesForCells={[0, 4, 5]}
                    customHeadCellClasses={[
                      classes.textCenter,
                      classes.textRight,
                      classes.textRight,
                      classes.textRight
                    ]}
                    customHeadClassesForCells={[0, 4, 5]}
                  />
                </CardBody>
              </Card>
              <Clearfix />
              <div className={classes.left} style={styles.marginTopBottom}>
                <Button onClick={() => {
                  this.props.history.goBack();
                }} type="button" color="success" round>
                  Back
                </Button>
              </div>
            </div>
            <Clearfix />
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isFetching: state.myBid.isFetching,
  stories: state.myBid.stories,
});

const mapDispatchToProps = dispatch => ({
  loadProjectLists: query => dispatch(getProjectList(query))
});

export default connect(
  mapStateToProps,
  {
    getUserStoryDetails,
    updateExistingBid
  }
)(withStyles(styles)(DetailStories));
